import React from "react";
import { createContext, useContext, type ReactNode } from "react"

// Define the types for our chart configuration
export type ChartConfig = {
  [key: string]: {
    label: string
    color: string
  }
}

// Create the context
type ChartContextType = {
  config: ChartConfig
  getColorByKey: (key: string) => string
  getLabelByKey: (key: string) => string
}

const ChartContext = createContext<ChartContextType | undefined>(undefined)

// Create a provider component
export function ChartProvider({
  children,
  config,
}: {
  children: ReactNode
  config: ChartConfig
}) {
  // Helper functions to get color and label by key
  const getColorByKey = (key: string) => {
    return config[key]?.color || "#888888"
  }

  const getLabelByKey = (key: string) => {
    return config[key]?.label || key
  }

  return <ChartContext.Provider value={{ config, getColorByKey, getLabelByKey }}>{children}</ChartContext.Provider>
}

// Create a hook to use the chart context
export function useChartContext() {
  const context = useContext(ChartContext)
  if (context === undefined) {
    throw new Error("useChartContext must be used within a ChartProvider")
  }
  return context
}

